import React, { useEffect } from 'react'
import ReactMarkdown from 'markdown-to-jsx'

import BEMHelper from '@ynap/bem-helper'
import { AsyncButton } from '@ynap/button'

const bem = new BEMHelper('ReturnLabelButton')

const ReturnLabelButton = ({
    fetchReturnLabel,
    clearReturnLabelState,
    returnLabelSuccess,
    returnLabelError,
    isFetchingReturnLabel,
    returnOrExchangeId,
    externalOrderId,
    email,
    locale,
    isConfirmationPage,
    messages,
    className,
}) => {
    const hasRequested = returnLabelSuccess || returnLabelError === 'ERR_UNABLE_TO_REPRINT_LABEL'
    const errorModifier = returnLabelError && returnLabelError !== 'ERR_UNABLE_TO_REPRINT_LABEL' ? 'redMessage' : ''

    const asyncState = {
        error: returnLabelError,
        loading: isFetchingReturnLabel,
        primaryAction: {
            message: messages.createCollection.returnLabelBtn({ hasRequested }),
            click: () => fetchReturnLabel(returnOrExchangeId, externalOrderId, email),
        },
    }

    useEffect(() => {
        clearReturnLabelState()
    }, [])

    return (
        <div className={bem(null, null, className)}>
            {isConfirmationPage && (
                <div className={bem('infoMessage', null, className)}>
                    <ReactMarkdown
                        options={{
                            overrides: {
                                a: (props) => (
                                    <a
                                        className={bem('link')}
                                        href={props.href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {props.children}
                                    </a>
                                ),
                            },
                        }}
                    >
                        {messages.createCollection.returnLabelInfo({ locale: locale?.id })}
                    </ReactMarkdown>
                </div>
            )}

            <AsyncButton
                type="secondary"
                className={bem('getReturnLabelButton', null, className)}
                disabled={hasRequested}
                asyncState={asyncState}
                displayLoading={true}
            />

            {(returnLabelSuccess || returnLabelError) && (
                <div className={bem('requestMessage', errorModifier, className)}>
                    {returnLabelSuccess && messages.createCollection.returnLabelSuccess()}
                    {returnLabelError && messages.createCollection.returnLabelError({ error: returnLabelError })}
                </div>
            )}
        </div>
    )
}

export default ReturnLabelButton
